import { useContext, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { ReducerState } from '../../reducers';
import { useConfig } from '../../default-config';
import { Translations } from '../../types';
import { LanguageContext, LanguageContextType } from '../../context/LanguageContext';

/** ************************************************************************
 ************************************************************************* */
export const usePrevious = (value: any): any => {
 	const reference = useRef<any>(null);
 	useEffect(() => {
   		reference.current = value;
  	}, [value]);
  	return reference.current;
};

/** ************************************************************************
 ************************************************************************* */
export const useSiteLang = (): LanguageContextType => useContext(LanguageContext);

/** ************************************************************************
 ************************************************************************* */
export const useTranslation = (): Translations => {
    const { texts } = useConfig();
    const { siteLang } = useSiteLang();
    return texts[siteLang] || texts.nb || {};
};

/** ************************************************************************
 ************************************************************************* */
export const useActivation = () => {
    return useSelector((appState: ReducerState) => appState.activation);
};

/** ************************************************************************
 ************************************************************************* */
export const useOverview = () => {
    return useSelector((appState: ReducerState) => appState.overview);
};
